import React from "react";

import {

    ResponsiveContainer,

    PieChart,

    Pie,

    Tooltip,

    Legend,

    Cell,

} from "recharts";

import "../../styles/OrderStatusChart.css";

const COLORS = [

    "#0088FE",

    "#00C49F",

    "#FFBB28",

    "#FF8042",

    "#d62828",

];

const OrderStatusChart = ({ data = [] }) => {

    return (

        <div className="chart-card">

            <h3>Order Status</h3>

            <ResponsiveContainer
                width="100%"
                height={320}
            >

                <PieChart>

                    <Pie
                        data={data}
                        dataKey="value"
                        nameKey="name"
                        outerRadius={110}
                        label
                    >

                        {data.map((entry, index) => (

                            <Cell
                                key={index}
                                fill={
                                    COLORS[
                                        index %
                                            COLORS.length
                                    ]
                                }
                            />

                        ))}

                    </Pie>

                    <Tooltip />

                    <Legend />

                </PieChart>

            </ResponsiveContainer>

        </div>

    );

};

export default OrderStatusChart;